import { motion } from "framer-motion";
import { Badge } from "@/components/ui/badge";
import type { Campaign } from "./types";
import { CHANNELS } from "./constants";

interface Props {
  channel: typeof CHANNELS[0];
  campaigns: Campaign[];
  isHovered: boolean;
}

export function ChannelDropZone({ channel, campaigns, isHovered }: Props) {
  const Icon = channel.icon;
  const count = campaigns.length;
  const totalSpent = campaigns.reduce((s, c) => s + c.spent, 0);
  const totalConversions = campaigns.reduce((s, c) => s + c.conversions, 0);
  const avgCpc = campaigns.reduce((s, c) => s + c.cpc, 0) / (count || 1);

  return (
    <motion.div
      data-channel-drop={channel.id}
      animate={{
        scale: isHovered ? 1.03 : 1,
        borderColor: isHovered ? channel.color : "hsl(var(--border))",
      }}
      transition={{ type: "spring", stiffness: 400, damping: 25 }}
      className="relative rounded-xl border-2 border-dashed p-3 flex flex-col items-center gap-1.5 min-h-[80px] transition-colors"
      style={{ background: isHovered ? channel.color + "10" : "transparent" }}
    >
      <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: channel.color + "22" }}>
        <Icon className="h-4 w-4" style={{ color: channel.color }} />
      </div>
      <span className="text-[10px] font-medium text-center leading-tight">{channel.name}</span>
      {count > 0 && (
        <>
          <Badge variant="secondary" className="text-[9px] px-1.5 py-0">
            {count} campagne{count > 1 ? "s" : ""}
          </Badge>
          <div className="text-[8px] text-muted-foreground/60 space-y-0.5 text-center">
            {totalSpent > 0 && <div>{totalSpent.toLocaleString("fr-FR")}€ dépensé</div>}
            {totalConversions > 0 && <div>{totalConversions} conversions</div>}
            {avgCpc > 0 && <div>CPC moy: {avgCpc.toFixed(2)}€</div>}
          </div>
        </>
      )}
    </motion.div>
  );
}
